// Pushes a custom event to the GTM data layer.
//
// GTM only recognises pushed *objects* carrying an `event` key. Pushing a bare
// string is silently ignored - no trigger can ever match it - so the event name
// has to be wrapped rather than passed straight through.
export function pushToDataLayer(event, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
}
